import { useCallback } from 'react';
import { QueryFilters } from '@tanstack/react-query';
import { removeQueries } from '../utils/query-client-methods';

/**
 * @deprecated use {@link removeQueries `removeQueries`}
 */
export function useRemoveQueries(queryFilters?: QueryFilters) {
  return useCallback(() => {
    removeQueries(queryFilters);
  }, [queryFilters]);
}
